import { Site } from '@envato/foundation-types'

import { Consent, consented } from '../consent'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../localStorageHelpers'

const itemKey = (site: Site) => {
  return `${site}-search-page-views`
}

export const shouldTrackSearchCount = (site: Site) => {
  return site === Site.videohive
}

export const searchesCount = (site: Site) =>
  consented(Consent.statistics) ? getLocalStorageItem(itemKey(site), 0) : 0

export const countSearchFor = (site: Site) => {
  const newCount = getLocalStorageItem(itemKey(site), 0) + 1
  setLocalStorageItem(itemKey(site), newCount)
}
